module.exports = require('./index.common');



/** WEBPACK FOOTER **
 ** ./index.js
 **/